import React, { useContext } from 'react';
import { Header, List, Button, Icon } from 'semantic-ui-react';
import Image from '../../../../../../atoms/Image';
import MarkdownField from '../../../../../../components/MarkdownContent';
import { GatsbyImagePropType, MenuItemVariationPropType } from '../../../../../../services/proptypes';
import { FoodMenuCartContext, MenuContext } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import { ModifierSetsBasic } from '../../modifiers';
import ItemInteraction from '../ItemInteraction';
import ItemVariations from '../ItemVariations';
import './LeftImageItemHorizontalCard.css';
var defaultProps = {
  description: null,
  image: null,
  imageAltText: '',
  className: '',
  gatsbyImage: null,
  variations: [],
  displayImages: true
};
export default function LeftImageItemHorizontalCard(_ref) {
  var id = _ref.id,
    name = _ref.name,
    description = _ref.description,
    image = _ref.image,
    imageAltText = _ref.imageAltText,
    gatsbyImage = _ref.gatsbyImage,
    variations = _ref.variations,
    onClick = _ref.onClick,
    className = _ref.className,
    displayImages = _ref.displayImages;
  var _useContext = useContext(MenuContext),
    items = _useContext.items,
    modifierSets = _useContext.modifierSets,
    disableModifiers = _useContext.disableModifiers,
    precision = _useContext.precision,
    displayZeroCostItemPrices = _useContext.displayZeroCostItemPrices,
    displayZeroCostModifierPrices = _useContext.displayZeroCostModifierPrices;
  var cart = useContext(FoodMenuCartContext);
  var item = MenuUtil.getItemById(items, id);
  var itemModifierSetIds = item.modifierSets;
  var itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);
  return /*#__PURE__*/React.createElement(List.Item, {
    className: "left-image-item-horizontal-card ".concat(className),
    onClick: onClick
  }, displayImages && /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(Image, {
    src: gatsbyImage || image,
    className: "image",
    altText: imageAltText
  })), /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-container"
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "header-text"
  }, name)), /*#__PURE__*/React.createElement(ItemVariations, {
    variations: variations,
    precision: precision,
    displayZeroCostItemPrices: displayZeroCostItemPrices
  })), /*#__PURE__*/React.createElement(MarkdownField, {
    className: "description markdown"
  }, description), !disableModifiers && /*#__PURE__*/React.createElement("div", {
    className: "modifiers-container"
  }, /*#__PURE__*/React.createElement(ModifierSetsBasic, {
    modifierSets: itemModifierSets,
    displayZeroCostModifierPrices: displayZeroCostModifierPrices
  })), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item-interaction-container"
  }, /*#__PURE__*/React.createElement(ItemInteraction, {
    item: item
  })), cart && /*#__PURE__*/React.createElement(Button, {
    icon: true,
    className: "add-to-cart"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cart plus"
  })))));
}
LeftImageItemHorizontalCard.defaultProps = defaultProps;